import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import List from './components/List';
import ListDraggableItem from './components/ListDraggableItem';

import { Subcontent } from './Subcontent';

const DragAndDropSubcontent = ({
  contentList,
  isMobile,
  hideEdit,
  hideDelete,
  editTooltipText,
  deleteTooltipText,
  onDragFinish,
}) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (contentList.length > 0) {
      setItems(contentList);
    }
  }, [contentList]);

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const newItems = reorder(items, result.source.index, result.destination.index);
    setItems(newItems);

    if (onDragFinish) {
      onDragFinish(newItems);
    }
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable">
        {(provided, snapshot) => (
          <List provided={provided} innerRef={provided.innerRef}>
            {items.map((item, index) => (
              <Draggable draggableId={`draggable-${index}`} key={`key-${index}`} index={index}>
                {(provided, snapshot) => (
                  <ListDraggableItem
                    provided={provided}
                    snapshot={snapshot}
                    innerRef={provided.innerRef}
                    label={item.label}
                    sublabel={item.sublabel}
                    disableDelete={item.disableDelete}
                    onEditClick={item.onEdit}
                    onDeleteClick={item.onDelete}
                    editTooltipText={item.editTooltipText || editTooltipText}
                    deleteTooltipText={item.deleteTooltipText || deleteTooltipText}
                    hideEdit={item.hideEdit || hideEdit}
                    hideDelete={item.hideDelete || hideDelete}
                    isMobile={isMobile}
                  />
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </List>
        )}
      </Droppable>
    </DragDropContext>
  );
};

Subcontent.propTypes = {
  contentList: PropTypes.array,

  isMobile: PropTypes.bool,

  hideEdit: PropTypes.bool,

  hideDelete: PropTypes.bool,

  onDragFinish: PropTypes.func,
};

Subcontent.defaultProps = {
  contentList: [],
  isMobile: false,
  hideEdit: false,
  hideDelete: false,
};

export { DragAndDropSubcontent };
